import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { InboxPage } from './inbox';

import { InboxCreateTimeeventPageModule } from '../inbox-create-timeevent/inbox-create-timeevent.module';

@NgModule({
  declarations: [
    InboxPage,
  ],
  imports: [
    IonicPageModule.forChild(InboxPage),
    InboxCreateTimeeventPageModule
  ]
})
export class InboxPageModule {}



// WEBPACK FOOTER //
// ./src/pages/inbox/inbox.module.ts